
import React from 'react';
import { PreviousReportTable } from './PreviousReportTable';
import { Report } from '@/types/report';

interface PreviousReportContentProps {
  loading: boolean;
  error: Error | null;
  reports: Report[];
  onTogglePin: (report: Report) => void;
  onSelectReport: (reportId: string) => void;
}

export const PreviousReportContent: React.FC<PreviousReportContentProps> = ({
  loading,
  error,
  reports,
  onTogglePin,
  onSelectReport
}) => {
  if (loading) {
    return <div className="py-6 text-center">กำลังโหลดข้อมูล...</div>;
  }
  
  if (error) {
    return (
      <div className="py-6 text-center text-destructive">
        เกิดข้อผิดพลาดในการโหลดข้อมูล
      </div>
    );
  }
  
  if (reports.length === 0) {
    return <div className="py-6 text-center">ไม่พบรายงานที่ผ่านมา</div>;
  }
  
  return (
    <PreviousReportTable 
      reports={reports} 
      onTogglePin={onTogglePin} 
      onSelectReport={onSelectReport} 
    />
  );
};
